
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type FacetDialogVehicleSpecsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function FacetDialogVehicleSpecsRT(): TemplateResult<FacetDialogVehicleSpecsRTRootProps> {
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-header' }, _createElement('div', { 'className': 'dialog-title-container' }, _createElement('div', { 'className': 'dialog-title' }, _translate(`facet_dialog_title`)), _createElement('div', { 'className': 'total-hits' }, this.totalHits, ' ', _translate(`facet_dialog_results`))), _createElement('div', { 'className': 'buttons-container' }, _createElement('div', {
        'className': 'cm_button cm_facet-dialog_button-clear btn btn--secondary',
        'onClick': this.clear
    }, '\n          ', _translate(`facet_dialog_clear`), '\n        '), _createElement('div', {
        'className': 'cm_button cm_facet-dialog_button-done btn btn--primary',
        'onClick': this.close
    }, '\n          ', _translate(`facet_dialog_done`, {  totalHits : this. totalHits  }), '\n        '))), _createElement('div', { 'className': 'cm_FacetPanel cm_facet-panel__full-width dialog-body' }, [this.vehicleSpecs(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-popular',
                                        'disabled': true,
                                        'key': '11021'
                                    }, _translate(`ymm_bar_popular`)),
                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-unpopular',
                                        'disabled': true,
                                        'key': '11024'
                                    }, _translate(`ymm_bar_unpopular`))
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        function scopeShowSelectedValues4() {
                            var showSelectedValues = this.selectedEntries.length;
                            return _createElement('option', {
                                'key': '_current',
                                'value': '_current'
                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                _translate(`select_title`),
                                ' ',
                                this.title
                            ] : null);
                        }
                        function repeatEntry5(entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => this.onChange(entry.term)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '3324'
                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                'className': 'cm_dropdown_hitCount',
                                'key': '3526'
                            }, entry.hitCount) : null);
                        }
                        return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                            'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                            'key': '39'
                        }, _createElement('select', {
                            'className': 'cm_select_inner-select cm_select__pretty',
                            'onChange': this.onChange,
                            'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                    return _createElement('div', { 'className': 'cm_filterInput' });
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                'aria-label': this.title,
                                'key': '2586'
                            },
                            !this.hideNullOption ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'onClick': () => this.onChange('')
                            }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                            this.loading ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'disabled': true
                            }, _translate(`select_loading`)) : null,
                            !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                        ]) : null);
                    }, { count: undefined })];
            }
            return !!window.Convermax.config?.extraFieldsAsFilters && this.selects.length ? _createElement('div', {
                'className': 'cm_vehicleSpecs',
                'key': '0'
            }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', { 'className': 'facettitle' }, _createElement('span', {}, _translate(`vehicle_specs_title`)), _createElement('div', {
                'className': 'cm_button btn btn--secondary',
                'title': 'Reset',
                'onClick': this.discardExtraFields
            }, '\n              ', _translate(`vehicle_specs_reset`), '\n            ')), _createElement('div', { 'className': 'facetbody' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ])))) : null;
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [
        [[this.filterChips(function () {
                    function repeatChips1(chips, chipsIndex) {
                        return [chips(function () {
                                function repeatI1_reviewChip(i, iIndex) {
                                    return _createElement('span', {
                                        'key': `${ this.field }|${ i }`,
                                        'className': 'cm_star cm_star__' + (!(this.value - i) || this.value - i < 0.25 ? 'empty' : this.value - i < 0.75 ? 'half' : 'full')
                                    });
                                }
                                return this.template === 'chip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_chip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, _createElement('span', { 'className': 'cm_chip-name' }, this.name === 'filterQuery' ? _translate(`filter_search_box_current_search`) : this.name === 'query' ? _translate(`current_query_label`) : this.name, ':'), '\n  ', this.value, '\n'), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'width': '13',
                                        'height': '13',
                                        'viewBox': '0 0 13 13',
                                        'fill': 'none',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '3500'
                                    }, _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
                                        'fill': '#FF0000'
                                    }), _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
                                        'fill': '#FF0000'
                                    }), _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
                                        'stroke': '#FF0000',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
                                        'stroke': '#FF0000',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }))])) : this.template === 'reviewChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_reviewChip' }, _createElement.apply(this, [
                                    'a',
                                    {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    },
                                    _createElement('span', { 'className': 'cm_chip-name' }, this.name, ': '),
                                    _map([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ], repeatI1_reviewChip.bind(this)),
                                    this.value !== '5' ? _createElement('span', { 'key': '391' }, ' and up') : null
                                ]), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'width': '13',
                                        'height': '13',
                                        'viewBox': '0 0 13 13',
                                        'fill': 'none',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '4900'
                                    }, _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
                                        'fill': '#FF0000'
                                    }), _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
                                        'fill': '#FF0000'
                                    }), _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
                                        'stroke': '#FF0000',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
                                        'stroke': '#FF0000',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }))])) : this.template === 'rangeChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_rangeChip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), this.finite ? [
                                    this.selectedRange[0],
                                    ' ',
                                    _translate(`ranged_facet_range_delimiter`),
                                    ' ',
                                    this.selectedRange[1]
                                ] : null, this.toPosInf ? [
                                    this.selectedRange[0],
                                    ' ',
                                    _translate(`ranged_facet_more`)
                                ] : null, this.toNegInf ? [
                                    this.selectedRange[1],
                                    ' ',
                                    _translate(`ranged_facet_less`)
                                ] : null), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'width': '13',
                                        'height': '13',
                                        'viewBox': '0 0 13 13',
                                        'fill': 'none',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '5360'
                                    }, _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
                                        'fill': '#FF0000'
                                    }), _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
                                        'fill': '#FF0000'
                                    }), _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M11.9226 0.744078C12.248 1.06951 12.248 1.59715 11.9226 1.92259L1.92259 11.9226C1.59715 12.248 1.06951 12.248 0.744078 11.9226C0.418641 11.5972 0.418641 11.0695 0.744078 10.7441L10.7441 0.744078C11.0695 0.418641 11.5972 0.418641 11.9226 0.744078Z',
                                        'stroke': '#FF0000',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }), _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M0.744078 0.744078C1.06951 0.418641 1.59715 0.418641 1.92259 0.744078L11.9226 10.7441C12.248 11.0695 12.248 11.5972 11.9226 11.9226C11.5972 12.248 11.0695 12.248 10.7441 11.9226L0.744078 1.92259C0.418641 1.59715 0.418641 1.06951 0.744078 0.744078Z',
                                        'stroke': '#FF0000',
                                        'strokeLinecap': 'round',
                                        'strokeLinejoin': 'round'
                                    }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_filterChips' }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', {
                        'className': 'facettitle',
                        'tabIndex': '0'
                    }, _translate(`selected_facets_label`)), _createElement('div', { 'className': 'facetbody' }, _createElement.apply(this, [
                        'div',
                        {
                            'role': 'list',
                            'className': 'cmRepeater_chips'
                        },
                        _map(this.chips, repeatChips1.bind(this))
                    ]), _createElement('div', {
                        'className': 'cm_btn btn btn--secondary cm_filter-chips_button',
                        'data-cm-role': 'start-over'
                    }, '\n        ', _translate(`selected_facets_clear`), '\n      '))));
                }, {
                    widgetName: 'filter-chips',
                    items: undefined
                })]],
        [this.facets(function () {
                function repeatFacets1(facets, facetsIndex) {
                    return [facets(function () {
                            function repeatShowAlwaysValues1(ShowAlwaysValues, ShowAlwaysValuesIndex) {
                                return [ShowAlwaysValues(function () {
                                        return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                            'type': 'checkbox',
                                            'className': 'cm_facet_checkbox',
                                            'readOnly': true,
                                            'checked': this.isSelected
                                        }), _createElement('a', {
                                            'className': 'facetentrykey',
                                            'tabIndex': '0',
                                            'role': 'listitem'
                                        }, this.value), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                    }, { count: undefined })];
                            }
                            function repeatValues2(Values, ValuesIndex) {
                                return [Values(function () {
                                        return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                            'type': 'checkbox',
                                            'className': 'cm_facet_checkbox',
                                            'readOnly': true,
                                            'checked': this.isSelected
                                        }), _createElement('a', {
                                            'className': 'facetentrykey',
                                            'tabIndex': '0',
                                            'role': 'listitem'
                                        }, this.value), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                    }, { count: undefined })];
                            }
                            function repeatValues3(Values, ValuesIndex) {
                                return [Values(function () {
                                        return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                            'type': 'checkbox',
                                            'className': 'cm_facet_checkbox',
                                            'readOnly': true,
                                            'checked': this.isSelected
                                        }), !this.isCustomRange ? [
                                            _createElement('a', {
                                                'className': 'facetentrykey',
                                                'tabIndex': '0',
                                                'role': 'listitem',
                                                'key': '1541'
                                            }, _createElement('span', {}, this.value)),
                                            _createElement('div', {
                                                'className': 'facetentryval',
                                                'key': '1543'
                                            }, this.hitCount)
                                        ] : null, this.isCustomRange ? [_createElement('a', {
                                                'className': 'facetentrykey',
                                                'tabIndex': '0',
                                                'role': 'listitem',
                                                'key': '3901'
                                            }, this.finite ? _createElement('span', { 'key': '503' }, this.range[0], ' - ', this.range[1]) : null, this.toPosInf ? _createElement('span', { 'key': '580' }, this.range[0], ' ', _translate(`ranged_facet_more`)) : null, this.toNegInf ? _createElement('span', { 'key': '676' }, this.range[1], ' ', _translate(`ranged_facet_less`)) : null)] : null);
                                    }, { count: undefined })];
                            }
                            function repeatShowAlwaysValues4(ShowAlwaysValues, ShowAlwaysValuesIndex) {
                                return [ShowAlwaysValues(function () {
                                        function scopeStarFill1(i, iIndex) {
                                            var starFill = this.value - i;
                                            return _createElement('span', {
                                                'key': i,
                                                'className': 'jdgm-star jdgm--' + (!starFill || starFill < 0.25 ? 'off' : starFill < 0.75 ? 'half' : 'on')
                                            });
                                        }
                                        function repeatI2(i, iIndex, starFill) {
                                            return scopeStarFill1.apply(this, [
                                                i,
                                                iIndex
                                            ]);
                                        }
                                        return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                            'type': 'checkbox',
                                            'className': 'cm_facet_checkbox',
                                            'readOnly': true,
                                            'checked': this.isSelected
                                        }), _createElement('a', {
                                            'className': 'facetentrykey jdgm-widget jdgm-preview-badge jdgm--done-setup',
                                            'tabIndex': '0',
                                            'role': 'listitem'
                                        }, _createElement.apply(this, [
                                            'span',
                                            { 'className': 'jdgm-prev-badge__stars' },
                                            _map([
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ], repeatI2.bind(this))
                                        ]), this.value !== '5' ? _createElement('span', {
                                            'className': 'cm_and-up',
                                            'key': '562'
                                        }, ' and up') : null), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                    }, { count: undefined })];
                            }
                            function repeatValues5(Values, ValuesIndex) {
                                return [Values(function () {
                                        function scopeStarFill1(i, iIndex) {
                                            var starFill = this.value - i;
                                            return _createElement('span', {
                                                'key': i,
                                                'className': 'jdgm-star jdgm--' + (!starFill || starFill < 0.25 ? 'off' : starFill < 0.75 ? 'half' : 'on')
                                            });
                                        }
                                        function repeatI2(i, iIndex, starFill) {
                                            return scopeStarFill1.apply(this, [
                                                i,
                                                iIndex
                                            ]);
                                        }
                                        return _createElement('div', { 'className': 'facetdiv ' + this.facetDivClass }, _createElement('input', {
                                            'type': 'checkbox',
                                            'className': 'cm_facet_checkbox',
                                            'readOnly': true,
                                            'checked': this.isSelected
                                        }), _createElement('a', {
                                            'className': 'facetentrykey jdgm-widget jdgm-preview-badge jdgm--done-setup',
                                            'tabIndex': '0',
                                            'role': 'listitem'
                                        }, _createElement.apply(this, [
                                            'span',
                                            { 'className': 'jdgm-prev-badge__stars' },
                                            _map([
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ], repeatI2.bind(this))
                                        ]), this.value !== '5' ? _createElement('span', {
                                            'className': 'cm_and-up',
                                            'key': '562'
                                        }, ' and up') : null), _createElement('div', { 'className': 'facetentryval' }, this.hitCount));
                                    }, { count: undefined })];
                            }
                            return _createElement('div', { 'className': 'facetholder cm_field-' + this.field }, this.template !== 'toggleFacet' ? [
                                _createElement('div', {
                                    'className': 'facettitle',
                                    'data-cm-role': 'toggle-facet',
                                    'tabIndex': '0',
                                    'key': '561'
                                }, _createElement('span', {}, this.name), [_createElement('svg', {
                                        'width': '10',
                                        'height': '6',
                                        'viewBox': '0 0 10 6',
                                        'fill': 'none',
                                        'xmlns': 'http://www.w3.org/2000/svg',
                                        'key': '2330'
                                    }, _createElement('path', {
                                        'fillRule': 'evenodd',
                                        'clipRule': 'evenodd',
                                        'd': 'M0.195262 0.195262C0.455612 -0.0650874 0.877722 -0.0650874 1.13807 0.195262L4.66667 3.72386L8.19526 0.195262C8.45561 -0.0650874 8.87772 -0.0650874 9.13807 0.195262C9.39842 0.455612 9.39842 0.877722 9.13807 1.13807L5.13807 5.13807C4.87772 5.39842 4.45561 5.39842 4.19526 5.13807L0.195262 1.13807C-0.0650874 0.877722 -0.0650874 0.455612 0.195262 0.195262Z',
                                        'fill': '#222222'
                                    }))]),
                                _createElement('div', {
                                    'className': 'facetbody' + (this.template === 'simpleFacet' && this.needShowMore && !this.moreValuesToShow ? ' expanded' : ''),
                                    'key': '563'
                                }, this.template === 'simpleFacet' ? _createElement('div', {
                                    'role': 'list',
                                    'className': 'cmTemplate_simpleFacet',
                                    'key': '977'
                                }, this.showFilterInput ? _createElement('div', {
                                    'className': 'filter-input',
                                    'key': '1075'
                                }, [this.filterInput(function () {
                                        return _createElement('div', {
                                            'className': 'input  cm_filterInput',
                                            'placeholder': _translate(`facet_filter_placeholder`)
                                        });
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })], this.inputNotEmpty ? _createElement('span', {
                                    'className': 'filter-input_clear-container',
                                    'onClick': this.clearInput,
                                    'key': '1414'
                                }, _createElement('span', { 'className': 'filter-input_clear' }, '\u2715')) : null) : null, !this.ShowAlwaysValues.length && !this.Values.length ? [_createElement('div', {
                                        'className': 'facetdiv',
                                        'key': '15831'
                                    }, _createElement('span', { 'className': 'facetentrykey' }, _translate(`facet_filter_nothing`)))] : null, _createElement('div', { 'className': 'facetvalues' + (this.showFilterInput && !this.moreValuesToShow ? ' overflowed' : '') }, _createElement.apply(this, [
                                    'div',
                                    { 'className': 'cmRepeater_ShowAlwaysValues' },
                                    _map(this.ShowAlwaysValues, repeatShowAlwaysValues1.bind(this))
                                ]), _createElement.apply(this, [
                                    'div',
                                    { 'className': 'cmRepeater_Values' },
                                    _map(this.Values, repeatValues2.bind(this))
                                ]), this.needShowMore ? _createElement('div', {
                                    'className': 'facetdiv cm_show-all-container',
                                    'key': '3395'
                                }, _createElement('a', {
                                    'className': 'cm_show-all',
                                    'data-cm-role': 'toggle-show-more',
                                    'tabIndex': '0'
                                }, this.moreValuesToShow ? [_translate(`show_more`, {  valuesCount : this. valuesCount  })] : null, !this.moreValuesToShow ? [_translate(`show_less`)] : null)) : null)) : null, this.template === 'selectFacet' ? _createElement('div', {
                                    'className': 'cmTemplate_selectFacet',
                                    'key': '3774'
                                }, [this.select(function () {
                                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                            return _createElement('option', {
                                                'disabled': this.loading,
                                                'value': entry.term,
                                                'key': entry.value
                                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                                        }
                                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                            return _createElement('option', {
                                                'disabled': this.loading,
                                                'value': entry.term,
                                                'key': entry.value
                                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                                        }
                                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                                            var isPopularField = popularEntries.length && unpopularEntries.length;
                                            return [
                                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                                    'value': '',
                                                    'key': 'null-option'
                                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                                this.loading ? _createElement('option', {
                                                    'key': 'loading-option',
                                                    'disabled': true
                                                }, _translate(`select_loading`)) : null,
                                                isPopularField ? [
                                                    _createElement('option', {
                                                        'className': 'cm_option_title cm_option-popular',
                                                        'disabled': true,
                                                        'key': '11251'
                                                    }, _translate(`ymm_bar_popular`)),
                                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                                    _createElement('option', {
                                                        'className': 'cm_option_title cm_option-unpopular',
                                                        'disabled': true,
                                                        'key': '11254'
                                                    }, _translate(`ymm_bar_unpopular`))
                                                ] : null,
                                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                                            ];
                                        }
                                        function scopeShowSelectedValues4() {
                                            var showSelectedValues = this.selectedEntries.length;
                                            return _createElement('option', {
                                                'key': '_current',
                                                'value': '_current'
                                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                                _translate(`select_title`),
                                                ' ',
                                                this.title
                                            ] : null);
                                        }
                                        function repeatEntry5(entry, index) {
                                            return _createElement('div', {
                                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                                'key': entry.value,
                                                'onClick': () => this.onChange(entry.term)
                                            }, this.showCheckboxes ? _createElement('input', {
                                                'type': 'checkbox',
                                                'readOnly': true,
                                                'checked': entry.selected,
                                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                                'key': '3347'
                                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                                'className': 'cm_dropdown_hitCount',
                                                'key': '3549'
                                            }, entry.hitCount) : null);
                                        }
                                        return _createElement('div', { 'className': 'cm_select' }, _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                                            'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                            'key': '62'
                                        }, _createElement('select', {
                                            'className': 'cm_select_inner-select cm_select__pretty',
                                            'onChange': this.onChange,
                                            'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                            'disabled': this.disabled,
                                            'aria-label': this.title
                                        }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                                    return _createElement('div', { 'className': 'cm_filterInput' });
                                                }, {
                                                    widgetName: 'undefined',
                                                    items: undefined
                                                })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                            'div',
                                            {
                                                'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                                'aria-label': this.title,
                                                'key': '2609'
                                            },
                                            !this.hideNullOption ? _createElement('div', {
                                                'className': 'option',
                                                'key': 'null-option',
                                                'onClick': () => this.onChange('')
                                            }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                            this.loading ? _createElement('div', {
                                                'className': 'option',
                                                'key': 'null-option',
                                                'disabled': true
                                            }, _translate(`select_loading`)) : null,
                                            !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                                        ]) : null));
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]) : null, this.template === 'priceFacet' ? _createElement('div', {
                                    'role': 'list',
                                    'className': 'cmTemplate_priceFacet',
                                    'key': '9629'
                                }, !this.ranges.length ? [
                                    _createElement('div', { 'key': '97251' }, this.selectedRawRange[0], ' ', _translate(`ranged_facet_range_delimiter`), ' ', this.selectedRawRange[1]),
                                    '\n  ',
                                    this.slider,
                                    '\n  ',
                                    _createElement('div', {
                                        'className': 'cm_flex',
                                        'key': '97253'
                                    }, _createElement('div', { 'className': 'cm_flex-grow' }, _translate(`ranged_facet_min`), ' ', this.rawMin), _createElement('div', {}, _translate(`ranged_facet_max`), ' ', this.rawMax))
                                ] : null, this.ranges.length ? [_createElement.apply(this, [
                                        'div',
                                        {
                                            'className': 'cmRepeater_Values',
                                            'key': '100901'
                                        },
                                        _map(this.Values, repeatValues3.bind(this))
                                    ])] : null, [this.Inputs(function () {
                                        return _createElement('div', { 'className': 'input cm_Inputs' }, [this.inputMin(function () {
                                                return _createElement('div', {
                                                    'placeholder': _translate(`ranged_facet_min`),
                                                    'className': 'cm_inputMin'
                                                });
                                            }, {
                                                widgetName: 'undefined',
                                                items: undefined
                                            })], _createElement('span', { 'className': 'separator' }, _translate(`ranged_facet_inputs_delimiter`)), [this.inputMax(function () {
                                                return _createElement('div', {
                                                    'placeholder': _translate(`ranged_facet_max`),
                                                    'className': 'cm_inputMax'
                                                });
                                            }, {
                                                widgetName: 'undefined',
                                                items: undefined
                                            })], _createElement('button', {
                                            'type': 'button',
                                            'className': 'cm_btn btn btn--secondary',
                                            'onClick': this.setCustomRange
                                        }, '\n    ', _translate(`ranged_facet_submit`), '\n  '));
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]) : null, this.template === 'sliderFacet' ? _createElement('div', {
                                    'className': 'cmTemplate_sliderFacet',
                                    'key': '12755'
                                }, _createElement('div', { 'className': 'facetslider' }, _createElement('div', { 'className': 'facetsliderinfo' }, '\n    ', _translate(`ranged_facet_selected_label`), ' ', this.selectedRange[0], ' ', _translate(`ranged_facet_range_delimiter`), '\n    ', this.selectedRange[1], '\n  '), '\n  ', this.slider, '\n  ', _createElement('div', { 'className': 'cm_slider-bounds' }, _createElement('div', { 'className': 'min' }, this.min), _createElement('div', { 'className': 'max' }, this.max), _createElement('div', { 'className': 'clear' }))), [this.Inputs(function () {
                                        return _createElement('div', { 'className': 'input cm_Inputs' }, this.inputMin ? [[this.inputMin(function () {
                                                    return _createElement('div', {
                                                        'placeholder': _translate(`ranged_facet_min`),
                                                        'className': 'cm_inputMin'
                                                    });
                                                }, {
                                                    widgetName: 'undefined',
                                                    items: undefined
                                                })]] : null, this.inputMin && this.inputMax ? _createElement('span', {
                                            'className': 'separator',
                                            'key': '347'
                                        }, _translate(`ranged_facet_inputs_delimiter`)) : null, this.inputMax ? [[this.inputMax(function () {
                                                    return _createElement('div', {
                                                        'placeholder': _translate(`ranged_facet_max`),
                                                        'className': 'cm_inputMax'
                                                    });
                                                }, {
                                                    widgetName: 'undefined',
                                                    items: undefined
                                                })]] : null, _createElement('button', {
                                            'type': 'button',
                                            'className': 'cm_btn btn btn--secondary',
                                            'onClick': this.setCustomRange
                                        }, '\n    ', _translate(`ranged_facet_submit`), '\n  '));
                                    }, {
                                        widgetName: 'undefined',
                                        items: undefined
                                    })]) : null, this.template === 'reviewFacet' ? _createElement('div', {
                                    'role': 'list',
                                    'className': 'cmTemplate_reviewFacet',
                                    'key': '14427'
                                }, _createElement.apply(this, [
                                    'div',
                                    { 'className': 'cmRepeater_ShowAlwaysValues' },
                                    _map(this.ShowAlwaysValues, repeatShowAlwaysValues4.bind(this))
                                ]), _createElement.apply(this, [
                                    'div',
                                    { 'className': 'cmRepeater_Values' },
                                    _map(this.Values, repeatValues5.bind(this))
                                ])) : null)
                            ] : null, this.template === 'toggleFacet' ? _createElement('div', {
                                'className': 'cmTemplate_toggleFacet',
                                'key': '17643'
                            }, _createElement('div', { 'className': 'facettitle cm_facet-toggle' }, _createElement('span', {}, this.name), _createElement('label', { 'className': 'cm_facet-toggle_switch' }, _createElement('input', {
                                'className': 'cm_facet-toggle_input',
                                'type': 'checkbox',
                                'checked': this.isToggled,
                                'onClick': this.toggleFacet
                            }), _createElement('span', { 'className': 'cm_facet-toggle_slider' })))) : null);
                        }, { count: undefined })];
                }
                return _createElement('div', { 'className': 'cm_facets' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cmRepeater_facets' },
                    _map(this.facets, repeatFacets1.bind(this))
                ]));
            }, {
                widgetName: 'undefined',
                items: undefined
            })]
    ])));
}
        export const componentNames = ["cm:filterInput","cm:vehicleSpecs","cm:filterChips","cm:filterInput","cm:filterInput","cm:select","cm:inputMin","cm:inputMax","cm:Inputs","cm:inputMin","cm:inputMax","cm:Inputs","cm:facets"]